/**
 * useGlobalMessages — R2: Global messages unread count across all projects.
 *
 * Polls the /api/messages/unread-summary endpoint which returns per-project
 * unread message counts for the current authenticated user.
 */
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface ProjectMessageSummary {
  project_id: string;
  project_name: string | null;
  unread_count: number;
  total_count: number;
  latest_message_content: string | null;
  latest_message_at: string | null;
  latest_sender_email: string | null;
}

export function useGlobalUnreadMessages() {
  return useQuery({
    queryKey: ['global-messages-unread'],
    queryFn: async () => {
      const response = await api.projectMessages.unreadSummary();
      return {
        summary: response.summary as ProjectMessageSummary[],
        total_unread: response.total_unread as number,
      };
    },
    // Refresh every 60 seconds — unread counts are non-critical
    staleTime: 60_000,
    refetchInterval: 60_000,
  });
}
